<div>
    <div class="mb-4">
        <p-toolbar>
            <ng-template #start>
                <div class="flex items-center gap-2">
                    <p-button
                        label="Close"
                        severity="danger"
                        (click)="backToList()"
                    ></p-button>
                    @if (realm) {
                    <p-button
                        label="Manage users"
                        icon="pi pi-users"
                        severity="secondary"
                        [outlined]="true"
                        [routerLink]="['/users']"
                        [queryParams]="{ realmId: realm.RealmId }"
                    ></p-button>
                    }
                </div>
            </ng-template>
            <ng-template #center>
                <a
                    class="font-bold text-2xl tracking-tight text-primary hover:underline inline-flex items-center gap-2 no-underline"
                    [href]="'https://' + realm?.Domain"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {{ realm?.Domain }}
                    <i
                        class="pi pi-external-link"
                        style="font-size: 0.85rem"
                    ></i>
                </a>
            </ng-template>
            <ng-template #end>
                <div class="flex items-center gap-3">
                    @if (saveError()) {
                    <span class="text-red-500 text-sm">{{ saveError() }}</span>
                    }
                    <p-tag
                        [value]="realm?.IsActive ? 'Active' : 'Inactive'"
                        [severity]="realm?.IsActive ? 'success' : 'danger'"
                    ></p-tag>
                    <p-button
                        label="Save all"
                        [loading]="saving()"
                        [disabled]="!hasUnsavedChanges()"
                        (click)="saveAll()"
                    ></p-button>
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <div class="card">
        <p-tabs value="0">
            <p-tablist>
                <p-tab value="0"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-cog"></i> General @if (generalDirty())
                        {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                @if (canManageSiteTemplate()) {
                <p-tab value="site-template"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-clone"></i> Site Template</span
                    ></p-tab
                >
                }
                <p-tab value="1"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-palette"></i> Branding @if
                        (brandingDirty()) {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                <p-tab value="2"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-money-bill"></i> Currency @if
                        (currencyDirty()) {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                <p-tab value="3"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-credit-card"></i> Payment @if
                        (paymentDirty()) {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                @if (isSkill()) {
                <p-tab value="4"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-wallet"></i> Withdraw @if
                        (withdrawDirty()) {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                }
                <p-tab value="kyc"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-verified"></i> KYC @if (kycDirty()) {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                <p-tab value="legal"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-shield"></i> Legal @if (legalDirty()) {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                <p-tab value="5"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-google"></i> Google @if (googleDirty())
                        {
                        <p-tag
                            severity="warn"
                            value="edited"
                            [rounded]="true"
                        />
                        }</span
                    ></p-tab
                >
                <p-tab value="6"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-file-edit"></i> Site Content</span
                    ></p-tab
                >
                <p-tab value="7"
                    ><span class="flex items-center gap-2"
                        ><i class="pi pi-th-large"></i> Games</span
                    ></p-tab
                >
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="0">
                    @if (realm) {
                    <app-website-info-general
                        [realm]="realm"
                        [(draft)]="supportDraft"
                        (realmReassigned)="realmReassigned.emit($event)"
                    />
                    }
                </p-tabpanel>

                @if (canManageSiteTemplate()) {
                <p-tabpanel value="site-template">
                    @if (realm) {
                    <app-website-info-site-template
                        [realm]="realm"
                        (realmUpdated)="realmReassigned.emit($event)"
                    />
                    }
                </p-tabpanel>
                }

                <p-tabpanel value="1">
                    @if (realm) {
                    <app-website-info-branding
                        [realm]="realm"
                        [(draft)]="brandingDraft"
                    />
                    }
                </p-tabpanel>

                <p-tabpanel value="2">
                    @if (realm) {
                    <app-website-info-currency
                        [realm]="realm"
                        [(draft)]="currencyDraft"
                        [(overridden)]="currencyOverridden"
                    />
                    }
                </p-tabpanel>

                <p-tabpanel value="3">
                    @if (realm) {
                    <app-website-info-payment
                        [realm]="realm"
                        [(fineraDraft)]="fineraDraft"
                        [(fineraWithdrawDraft)]="fineraWithdrawDraft"
                        [(paymentMethodDraft)]="paymentMethodDraft"
                    />
                    }
                </p-tabpanel>

                @if (isSkill()) {
                <p-tabpanel value="4">
                    @if (realm) {
                    <app-website-info-withdraw
                        [realm]="realm"
                        [(draft)]="withdrawDraft"
                        [(overridden)]="withdrawOverridden"
                    />
                    }
                </p-tabpanel>
                }

                <p-tabpanel value="kyc">
                    @if (realm) {
                    <app-website-info-kyc
                        [realm]="realm"
                        [(draft)]="kycDraft"
                        [(overridden)]="kycOverridden"
                    />
                    }
                </p-tabpanel>

                <p-tabpanel value="legal">
                    @if (realm) {
                    <app-website-info-legal
                        [realm]="realm"
                        [(draft)]="legalDraft"
                    />
                    }
                </p-tabpanel>

                <p-tabpanel value="5">
                    @if (realm) {
                    <app-website-info-google
                        [realm]="realm"
                        [(draft)]="googleDraft"
                    />
                    }
                </p-tabpanel>

                <p-tabpanel value="6">
                    @if (realm) {
                    <p-tabs value="faq">
                        <p-tablist>
                            <p-tab value="faq"
                                ><span class="flex items-center gap-2"
                                    ><i class="pi pi-question-circle"></i>
                                    FAQ</span
                                ></p-tab
                            >
                            <p-tab value="social"
                                ><span class="flex items-center gap-2"
                                    ><i class="pi pi-share-alt"></i> Social
                                    Links</span
                                ></p-tab
                            >
                        </p-tablist>
                        <p-tabpanels>
                            <p-tabpanel value="faq">
                                <app-website-info-faq
                                    [realmId]="realm.RealmId"
                                />
                            </p-tabpanel>
                            <p-tabpanel value="social">
                                <app-website-info-social
                                    [realmId]="realm.RealmId"
                                />
                            </p-tabpanel>
                        </p-tabpanels>
                    </p-tabs>
                    }
                </p-tabpanel>

                <p-tabpanel value="7">
                    @if (realm) {
                    <app-website-info-games
                        [realm]="realm"
                        [providerStatus]="providerStatus"
                    />
                    }
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
</div>

<p-toast />
